import { Select, SelectProps } from 'antd';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { useStateDebounce } from '@/hooks';
import { useAreas } from '@/core/domain/operational/Areas/Areas.hooks';
import { ListAreasQuery } from '@/core/domain/operational/Areas/Areas.types';

type Props = Omit<SelectProps, 'options'> & { queryFilter?: ListAreasQuery };

const AreaSelectField: React.FC<Props> = ({ queryFilter, ...props }) => {
  const [queryParam, setQueryParam] = useStateDebounce<string>();

  const { data, isFetching } = useAreas({
    ...queryFilter,
    name: queryParam,
    rows: 50,
    active: true,
  });

  const areas = flatInfiniteData(data);

  return (
    <Select
      allowClear
      showSearch
      onSearch={setQueryParam}
      filterOption={false}
      loading={isFetching}
      style={{ width: '100%' }}
      {...props}
      options={areas?.map((area) => ({
        value: area.id,
        label: area.name,
      }))}
    />
  );
};

export default AreaSelectField;
